import { render, staticRenderFns } from "./NegativeAiFeedbackModal.vue?vue&type=template&id=227e995c&scoped=true"
import script from "./NegativeAiFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./NegativeAiFeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./NegativeAiFeedbackModal.vue?vue&type=style&index=0&id=227e995c&prod&lang=css"
import style1 from "./NegativeAiFeedbackModal.vue?vue&type=style&index=1&id=227e995c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e995c",
  null
  
)

export default component.exports